import React from "react";
import Hero from "../components/Hero";
import HeroImage from "../../assets/images/MortgagesPage.jpg";
import ServicesGrid from "../components/ServicesGrid";
import GridImage1 from "../../assets/images/Mortgages Page (2).jpg";
import GridImage2 from "../../assets/images/Mortgages Page (3).jpg";
import GridImage3 from "../../assets/images/Mortgages Page (4).jpg";
import GridImage4 from "../../assets/images/Mortgages Page (5).jpg";
import Button from "../components/Button";
import { useNavigate } from "react-router-dom";
import FaqAccordion from "../components/FaqAccordion";

const faqItems = [
  {
    question: "How much could I potentially borrow?",
    answer:
      "The amount you can borrow is based on your income, existing financial commitments, and credit history. Lenders will assess your affordability by looking at your income and outgoings. For example, one first-time buyer might be able to borrow up to 5 times their annual gross income, while another might be capped at 3.5 times.",
  },
  {
    question: "How much of a deposit do I need?",
    answer:
      " The minimum deposit required varies, but generally, a larger deposit can lead to better interest rates and terms. A 5% deposit may be possible, saving 10% or 20% can give you access to more competitive deals.",
  },
  {
    question:
      "What is the difference between fixed and variable-rate mortgages?",
    answer:
      "A fixed-rate mortgage means the interest rate you pay will remain the same for a set period. Whereas, a variable-rate mortgage has an interest rate that can fluctuate based on market conditions. ",
  },
  {
    question: "Does my credit score affect my mortgage application?",
    answer:
      "Your credit score is a key factor for lenders when assessing your credit. A healthy credit report with a history of on time payments, will help demonstrate trust to lenders. Lenders will look at many things, including your repayment history. ",
  },
  {
    question: "What other costs are involved besides the deposit?",
    answer:
      " Beyond the deposit, you should budget for additional costs such as solicitor or conveyancing fees, valuation fees, arrangement fees from the lender, and stamp duty.  ",
  },
  {
    question: "What do mortgage lenders look at?",
    answer:
      "Lenders look at several factors which include credit score, income and current employment status, deposit amount and the value of the property you are looking to purchase.",
  },
];
const items = [
  {
    title: "First-Time Buyer",
    description: [
      "Buying your first home is a significant milestone. It may at times feel overwhelming and a large prospect but with a financial adviser by your side, we can answer any questions you may have. We can help you get that first step on the property ladder and ensure that you make the right decision for your future.",
      "In an initial conversation with us, we will take the time to find out more about you and discuss what your first steps should be.",
    ],
    image: GridImage1,
    imageAlt: "Keys exchange",
  },
  {
    title: "Remortgaging",
    description: [
      "If your mortgage is coming up for renewal and you are looking for assistance, we can help. As an independent whole of market firm, we have access to a vast array of mortgage products, which could help you find offers that may not be available on the high street.",
      "You can start looking at remortgaging up to 6 months before your fixed term comes to an end.",
    ],
    image: GridImage2,
    imageAlt: "Meeting",
  },
  {
    title: "Home Mover",
    description: [
      "Finding a new mortgage for your new home can be stressful and tiresome - looking for the right product, digging through confusing jargon, factoring in all of the costs.  At Ava Rose Mortgages we are here to help make the process as smooth as possible and guide you through every step, answering any questions you may have.",
      "We can search for a mortgage that will suit your lifestyle and long-term needs.",
    ],
    image: GridImage3,
    imageAlt: "Mortgage discussion",
  },
  {
    title: "Buy-To-Let",
    description: [
      "Whether you are looking to purchase your first Buy-to-Let property, or are building your portfolio - we're here to support you.",
      "Buy-to-Let mortgages can sometimes be more complex than a residential, but with our experience we can assist you on the journey.",
    ],
    image: GridImage4,
    imageAlt: "Buy to let",
  },
];

function MortgagePage() {
  const navigate = useNavigate();
  return (
    <>
      <Hero title={"Mortgages"} subtitle={""} backgroundImage={HeroImage} />
      <div className="text-button-container" style={{ maxWidth: "1200px", margin: "20px auto 10px auto" }}>
        <p>
          Whether you are a first-time buyer, looking to remortgage, move home
          or even build your buy-to-let portfolio – we are here to help.
        </p>
        <p>
          Ava Rose Mortgages has the experience required to guide you every step
          of the way, answering any questions you may have and listening to what
          your financial goals are, so we can help you achieve them.
        </p>
        <p>
          As an independent firm we can flexibly access a wide range of
          mortgages from the whole of the market, giving us the ability to find
          the right product that meets your needs.
        </p>
        <Button
          text="Start your journey with us"
          onClick={() => navigate("/contact")}
        />
      </div>
      <ServicesGrid items={items} />
      <div className="text-button-container" style={{ maxWidth: "1200px", margin: "20px auto 10px auto" }}>
        <p style={{ padding: "0.5rem" }}>
          Your home may be repossessed if you do not keep up repayments on your
          mortgage. The Financial Conduct Authority do not regulate buy to let
          mortgages.
        </p>
      </div>
      {/* <p>
        Your home may be repossessed if you do not keep up repayments on your
        mortgage. The Financial Conduct Authority do not regulate buy to let
        mortgages.
      </p> */}
      <FaqAccordion items={faqItems} />
    </>
  );
}

export default MortgagePage;
